<template>
  <InboxV2Empty v-if="empty && selectedCategory === FILTERED_CATEGORY" />
  <InboxV2FilteredPanel v-else-if="selectedCategory === FILTERED_CATEGORY" />
  <InboxV2AllPanel v-else-if="selectedCategory === ALL_CATEGORY" />
  <InboxV2UnreadPanel v-else-if="selectedCategory === UNREAD_CATEGORY" />
  <InboxV2SectionPanel
    v-else
    :items="groupedCommunication[selectedCategory]?.[selectedItem] ?? []"
  />
</template>

<script setup>
import { computed } from 'vue'

import {
  ALL_CATEGORY,
  FILTERED_CATEGORY,
  UNREAD_CATEGORY,
} from '@app/application/communication/screens/inbox/store/utils'
import InboxV2Empty from '@app/application/communication/screens/inbox/components/inbox-v2-empty.vue'
import InboxV2FilteredPanel from '@app/application/communication/screens/inbox/components/inbox-v2-filtered-panel.vue'
import InboxV2UnreadPanel from '@app/application/communication/screens/inbox/components/inbox-v2-unread-panel.vue'
import InboxV2SectionPanel from '@app/application/communication/screens/inbox/components/inbox-v2-section-panel.vue'
import useGroupedFilteredCommunications from '@app/application/communication/screens/inbox/composables/use-grouped-filtered-communications'
import InboxV2AllPanel from '@app/application/communication/screens/inbox/components/inbox-v2-all-panel.vue'

defineProps({
  selectedCategory: {
    type: String,
    required: true,
  },
  selectedItem: {
    type: String,
    required: true,
  },
})

const { groupedCommunication } = useGroupedFilteredCommunications()
const empty = computed(
  () => Object.keys(groupedCommunication.value).length === 0
)
</script>
